import { render } from "./MenuStock.vue?vue&type=template&id=0bf9ea7e&scoped=true"
import script from "./MenuStock.vue?vue&type=script&lang=js"
export * from "./MenuStock.vue?vue&type=script&lang=js"

import "./MenuStock.vue?vue&type=style&index=0&id=0bf9ea7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf9ea7e"]])

export default __exports__